<template>
  <v-row v-if="!token" justify="center">
    <v-dialog :value="!showBetaOverlay" persistent max-width="600px">
        <v-card>
          <v-toolbar color="green lighten-1" class="text-h5 elevation-0 mb-3">
              <v-toolbar-title>BETA NOTICE</v-toolbar-title>
          </v-toolbar>
          <v-card-text class="text-subtitle-1">
            Hello traders and welcome to Theta Harvest, where options sellers can ditch their spreadsheets and make trade logging a breeze.<br><br>
            This project is currently in beta and bugs do happen. If you do come across a bug or have a question about how an app feature works, please email the app administrator at <a href="mailto:admin@thetaharvest.com" target="_blank">admin@thetaharvest.com</a>.<br><br>
            <strong>By clicking "I Agree" you are agreeing to participate in the beta of Theta Harvest.</strong>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn text color="green" x-large @click="storeToken">I Agree</v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: 'BetaOverlay',
  props: ['showBetaOverlay'],
  data () {
    return {
      token: false
    }
  },
  methods: {
    storeToken () {
      window.localStorage.setItem('TH-agreed-to-beta', true)
      this.token = true
    }
  }
}
</script>
